import React from "react";
import { Routes, Route } from "react-router-dom";
import ScrollTop from "./chrome/ScrollTop";
import Home from "./views/Home";
import Capabilities from "./views/Capabilities";
import Capability from "./views/Capability";
import Approach from "./views/Approach";
import Studio from "./views/Studio";
import Contact from "./views/Contact";
import NotFound from "./views/NotFound";

const App = () => (
  <ScrollTop>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/capabilities" element={<Capabilities />} />
      <Route path="/capabilities/:slug" element={<Capability />} />
      <Route path="/approach" element={<Approach />} />
      <Route path="/studio" element={<Studio />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </ScrollTop>
);

export default App;
